module.exports = __webpack_public_path__ + "static/media/aeromeghLogo.8120632f.png";